module.exports = __webpack_public_path__ + "img/minus.5952c267.svg";